import hbgjAPI from './hbgj-api';
import hosts from '../hosts';

export default function(options) {
  return hbgjAPI.getCommonParams().then(commonParams => {
    const data = {
      ...commonParams,
      ...options.data
    };

    if (options.sidFields && options.sidFields.length > 0) {
      data.sid = hbgjAPI.generateSid(options.sidFields, data);
    }

    const headers = Object.assign({
      'content-type': 'application/x-www-form-urlencoded'
    }, options.headers);

    return {
      url: hosts.ticket + options.url,
      method: options.method,
      headers,
      data
    };
  });
}



// WEBPACK FOOTER //
// ./src/request/transformers/ticket.js